module.exports = __webpack_public_path__ + "media/src/images/partners/htw_berlin-5cd9cd43ee6e301ddee36dae3a2158ca.jpg";